import { css } from '@emotion/core'
import { media } from '@dw/helix'

export const tableStyles = css`
  margin-top: 4px;
  width: 100%;
`

export const linkStyles = css`
  background-color: transparent;
  width: 100%;
  display: inline;
  text-align: left;
  &:hover {
    color: #273751;
    background-color: transparent;
  }

  ${media.MEDIA_MIN_LARGE} {
    text-align: right;
  }
`

export const withEllipsisStyles = css`
  width: 90%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const checkboxStyles = css`
  margin-left: 0;

  ${media.MEDIA_MIN_LARGE} {
    margin-left: -12px;
  }
`

export const columnCheckboxStyles = css`
  display: none;
  ${media.MEDIA_MIN_LARGE} {
    display: flex;
  }
  ${checkboxStyles};
`
